import { useCallback, useState } from "react";

import { useKeystone } from "data/ss-data-hooks";
import { isError } from "data/ss-error";
import { type TingContextState } from "pages/offer/ting/ting-flow";

export type TingEnrollmentValues = {
  offeringId?: string;
  offerId?: string;
  insightPolicyId?: string;
  additionalDetails?: {
    firstName?: string;
    lastName?: string;
    emailAddress?: string;
    phone?: string;
    isMobilePhone?: boolean;
    consentSms?: boolean;
    addressLine1?: string | null;
    addressLine2?: string | null;
    city?: string | null;
    state?: string | null;
    postalCode?: string | null;
  };
};

export const useTingEnrollment = (state: TingContextState) => {
  const keystone = useKeystone();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const { firstName, lastName, emailAddress, phone, mobile } = state ?? {};

  const enrollTing = useCallback(
    async ({ eligibilityInfo, propertyAddress }) => {
      setLoading(true);
      setError(false);
      // const tingEnrollmentBody = {};
      const tingEnrollmentBody: TingEnrollmentValues = {
        offeringId: eligibilityInfo?.offeringId,
        offerId: eligibilityInfo?.offerId,
        insightPolicyId: eligibilityInfo?.insightPolicyId,
        additionalDetails: {
          firstName,
          lastName,
          emailAddress,
          phone,
          isMobilePhone: false,
          consentSms: mobile?.includes("isTextOk"),
          addressLine1: propertyAddress?.street1,
          addressLine2: propertyAddress?.street2,
          city: propertyAddress?.city,
          state: propertyAddress?.state,
          postalCode: propertyAddress?.zip,
        },
      };

      const response = await keystone.enrollTing(tingEnrollmentBody);
      if (isError(response)) {
        setError(true);
      }
      setLoading(false);

      return !isError(response);
    },
    [emailAddress, firstName, keystone, lastName, mobile, phone],
  );

  return { enrollTing, loading, error };
};
